export default function CostSummary({ bom }) {
  if (!bom) return null;

  const low = parseFloat(bom.estimated_cost_low) || 0;
  const mid = parseFloat(bom.estimated_cost_mid) || 0;
  const high = parseFloat(bom.estimated_cost_high) || 0;
  const retailLow = parseFloat(bom.suggested_retail_low) || 0;
  const retailHigh = parseFloat(bom.suggested_retail_high) || 0;

  return (
    <div className="space-y-4">
      {/* Landed Cost Range */}
      <div>
        <div className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-2">Estimated Landed Cost</div>
        <div className="grid grid-cols-3 gap-3">
          <div className="bg-green-50 rounded-lg p-3 text-center">
            <div className="text-xs text-green-600 font-medium">Optimistic</div>
            <div className="text-lg font-bold text-green-700">${low.toFixed(2)}</div>
            <div className="text-xs text-green-500">10k+ units</div>
          </div>
          <div className="bg-blue-50 rounded-lg p-3 text-center">
            <div className="text-xs text-blue-600 font-medium">Moderate</div>
            <div className="text-lg font-bold text-blue-700">${mid.toFixed(2)}</div>
            <div className="text-xs text-blue-500">3k-10k units</div>
          </div>
          <div className="bg-orange-50 rounded-lg p-3 text-center">
            <div className="text-xs text-orange-600 font-medium">Conservative</div>
            <div className="text-lg font-bold text-orange-700">${high.toFixed(2)}</div>
            <div className="text-xs text-orange-500">&lt;3k units</div>
          </div>
        </div>
      </div>

      {/* Retail Range */}
      {(retailLow > 0 || retailHigh > 0) && (
        <div>
          <div className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-2">Suggested Retail Price</div>
          <div className="bg-vault-surface rounded-lg p-3 text-center">
            <div className="text-xl font-bold text-vault-navy">
              ${retailLow.toFixed(2)} - ${retailHigh.toFixed(2)}
            </div>
            <div className="text-xs text-gray-400 mt-1">Based on standard toy industry keystone multiples</div>
          </div>
        </div>
      )}

      {/* Viability */}
      <div>
        <div className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-2">Retail Viability</div>
        <div className={`p-3 rounded-lg border ${
          bom.retail_viable
            ? 'bg-green-50 border-green-200'
            : 'bg-red-50 border-red-200'
        }`}>
          <div className="flex items-center gap-2 mb-1">
            <span className={`text-sm font-semibold ${bom.retail_viable ? 'text-green-700' : 'text-vault-error'}`}>
              {bom.retail_viable ? 'Viable for Retail' : 'Retail Viability Concern'}
            </span>
          </div>
          {bom.viability_notes && (
            <p className="text-sm text-gray-600">{bom.viability_notes}</p>
          )}
        </div>
      </div>
    </div>
  );
}
